<template>
  <div class="d-flex flex-column full-width full-height">
    <div class="d-flex flew-row flex-wrap">
      <EcsOrganizationSummary
        class="summary-header-item pa-4"
        :organization-name="summaryView.organizationName || ''"
        :product-version="summaryView.productVersion || ''"
        :channels="summaryView.totalChannels || 0"
        :agents="summaryView.totalAgents || 0"
        :supervisors="summaryView.totalSupervisors || 0"
        :business-processes="summaryView.totalBusinessProcesses || 0"
        :is-loading="isLoading"
      />
      <EcsLicensingSummary
        class="summary-header-item pa-4"
        :concurrent-agents="summaryView.concurrentAgents || 0"
        :concurrent-supervisors="summaryView.concurrentSupervisors || 0"
        :concurrent-wallboards="summaryView.concurrentWallboards || 0"
        :is-loading="isLoading"
      />
    </div>
    <EcsBusinessProcessSummary
      class="business-process-summary-container d-flex flex-column flex-grow-1"
      :business-processes="summaryView.businessProcesses || []"
      :default-from-email="summaryView.defaultFromEmailAddress || ''"
      :default-bcc-email="summaryView.defaultBccEmailAddress || ''"
      :is-loading="isLoading"
    />
  </div>
</template>

<script>
import EcsOrganizationSummary from '@/components/ecs-summary-view/EcsOrganizationSummary';
import EcsLicensingSummary from '@/components/ecs-summary-view/EcsLicensingSummary';
import EcsBusinessProcessSummary from '@/components/ecs-summary-view/EcsBusinessProcessSummary';
import isEmpty from 'lodash/isEmpty';
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'EcsSummaryView',
  components: { EcsOrganizationSummary, EcsLicensingSummary, EcsBusinessProcessSummary },
  computed: {
    ...mapGetters(['summaryView']),
    isLoading() {
      return isEmpty(this.summaryView);
    }
  },
  mounted() {
    this.getSummaryView();
  },
  methods: {
    ...mapActions(['getSummaryView'])
  }
};
</script>

<style scoped>
.summary-view {
  width: 100%;
}
.summary-header-item {
  min-width: 350px;
  flex-basis: 50%;
}
@media only screen and (max-width: 730px) {
  .summary-header-item {
    min-width: 350px;
    flex-basis: 100%;
  }
}
</style>
